module.exports = __webpack_public_path__ + "4e8860fcc65fd2d7e2e039739b1c21e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/questions.png
// module id = 587
// module chunks = 0